import "./ChangePasswordModal.scss"
import { FC, useState } from "react"
import { Button } from "@mui/material"
import mainLogo from "../../../assets/images/logo2.png"
import { changePasswordAsync } from "../../../redux/slices/authSlice"
import { useAppDispatch } from "../../../redux/hooks"
import GenericModal from "../GenericAppModal/GenericModal.component"
import useFormValidation from "../../../hooks/useFormValidation"
import { useTranslationLabel } from "../../../hooks/useTranslationLabel"
import { ModalTypes, showModal } from "../../../redux/slices/modalSlice"
import likeIcon from "../../../assets/images/like.png"
import WarningIcon from "../../../assets/icons/WarningIcon"
import AppInput from "../../AppInput/AppInput.component"
import { useValidationSchemas } from "../../../hooks/useIsValidationScehemes"

type ChangePasswordModalProps = {
  open: boolean
  handleClose: () => void
}

const ChangePasswordModal: FC<ChangePasswordModalProps> = ({
  open,
  handleClose,
}) => {
  const {
    CHANGE_PASSWORD_MODAL_TITLE,
    CHANGE_PASSWORD_MODAL_DESCRIPTION,
    INPUT_CURRENT_PASSWORD,
    INPUT_NEW_PASSWORD,
    INPUT_CONFIRM_NEW_PASSWORD,
    BTN_CONFIRM,
    SIMPLE_MODAL_SUCCESS_TITLE,
    SIMPLE_MODAL_ERROR_TITLE,
    INCORRECT_PASSWORD,
    CHANGE_PASSWORD_MODAL_SUCCESS_DESCRIPTION,
  } = useTranslationLabel()

  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)
  const { changePasswordInitialValues, changePasswordSchema } =
    useValidationSchemas()
  const { formData, errors, handleChange, validateField, validateForm } =
    useFormValidation(changePasswordInitialValues, changePasswordSchema)

  const handleSubmit = async () => {
    if (validateForm()) {
      setLoading(true)
      const reqData = {
        oldPassword: formData.currentPassword,
        newPassword: formData.newPassword,
      }
      await dispatch(changePasswordAsync(reqData))
        .unwrap()
        .then((res) => {
          dispatch(
            showModal({
              activeModal: ModalTypes.SIMPLE_MODAL,
              data: {
                title: SIMPLE_MODAL_SUCCESS_TITLE,
                description: CHANGE_PASSWORD_MODAL_SUCCESS_DESCRIPTION,
                image: likeIcon,
              },
            }),
          )
        })
        .catch((err) => {
          dispatch(
            showModal({
              activeModal: ModalTypes.SIMPLE_MODAL,
              data: {
                title: SIMPLE_MODAL_ERROR_TITLE,
                description: INCORRECT_PASSWORD,
                image: <WarningIcon />,
              },
            }),
          )
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }

  return (
    <GenericModal
      open={open}
      handleClose={handleClose}
      title={CHANGE_PASSWORD_MODAL_TITLE}
      className="reset-password-modal"
      loading={loading}
      image={mainLogo}
      description={CHANGE_PASSWORD_MODAL_DESCRIPTION}
    >
      <div className="form-container">
        <AppInput
          label={INPUT_CURRENT_PASSWORD}
          name="currentPassword"
          value={formData.currentPassword}
          type="password"
          error={errors.currentPassword}
          onChange={handleChange}
        />

        <AppInput
          label={INPUT_NEW_PASSWORD}
          name="newPassword"
          value={formData.newPassword}
          type="password"
          error={errors.newPassword}
          onChange={handleChange}
        />

        <AppInput
          label={INPUT_CONFIRM_NEW_PASSWORD}
          name="confirmPassword"
          value={formData.confirmPassword}
          type="password"
          error={errors.confirmPassword}
          onChange={handleChange}
        />

        <Button
          variant="contained"
          className="primary-btn"
          onClick={handleSubmit}
        >
          {BTN_CONFIRM}
        </Button>
      </div>
    </GenericModal>
  )
}

export default ChangePasswordModal
